import React from 'react'

const CardHeader = ({ message, title }) => {
    return (
        <>
        {title && <h1>{title}</h1>}
        {message && <p>{message}</p>}
        </>
    )
}

export default CardHeader
